import React from 'react';

export function EasyCustomerInfo() {

    return (
        <>
            <div style={{
                width: '100%',
                backgroundColor: '#3da2d9',
                padding: '20px',
                paddingLeft: '30px',
                marginBottom: '0px',
                color: 'white',
                marginTop: '20px',
                textAlign: 'left',
            }}>
                Ihre Kundennummer scheint mit 1 oder 7 zu beginnen.
                Bitte nutzen Sie das folgende Formular:
                <a target="_blank" href="https://forms.ewe.de/kontaktformular-zaehlerstand-mitteilen">
                    <span style={{textDecoration: 'underline', color: 'white', marginLeft: '5px'}}>EWE Zählerstandsmitteilung</span>
                </a>
            </div>
        </>
    );

}